import { Component, Input } from "@angular/core";

import { ServiceObject } from "app/models/serviceObject";

@Component({
  templateUrl: './service-object-popup.component.html',
  styleUrls: ['./service-object-popup.component.scss']
})
export class ServiceObjectPopupComponent {

  @Input("serviceObject")
  public serviceObject: ServiceObject;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/serviceObject/map/popup/service-object-popup.component.ts